import React from 'react';
import RegenerateButton from '../components/RegenerateButton';
import { formatTimeAgo } from '../utils/date';

export default function InsightsHeader({
  reviewsAnalyzed = 0,
  feedbacksAnalyzed = 0,
  fetchedAt,
  onRegenerate,
  regenerating,
  cooldownRemainingMs,
  fallbackMode,
}) {
  const subtitleParts = [];
  if (reviewsAnalyzed > 0) {
    // Vague 10 commit 2/3 — bonus brief : exposer aussi feedbacks_analyzed quand > 0
    // pour que l'utilisateur voie le périmètre exact de l'analyse IA (avis Google + feedbacks privés).
    const count = feedbacksAnalyzed > 0
      ? `${reviewsAnalyzed} avis · ${feedbacksAnalyzed} feedbacks privés`
      : `${reviewsAnalyzed} avis`;
    subtitleParts.push(`Analyse de vos ${count}`);
  }
  if (fetchedAt) subtitleParts.push(`Mis à jour ${formatTimeAgo(fetchedAt)}`);

  return (
    <div style={styles.wrapper}>
      <div style={styles.row}>
        <div>
          <h1 style={styles.title}>
            <span aria-hidden>🧠</span> Insights IA
          </h1>
          {subtitleParts.length > 0 && (
            <p style={styles.subtitle}>{subtitleParts.join(' · ')}</p>
          )}
        </div>
        <RegenerateButton
          onClick={onRegenerate}
          regenerating={regenerating}
          cooldownRemainingMs={cooldownRemainingMs}
        />
      </div>
      {fallbackMode && (
        <div style={styles.fallback}>
          <span aria-hidden>⚠️</span>
          <span>Analyse temporairement indisponible — réessayez dans quelques instants.</span>
        </div>
      )}
    </div>
  );
}

const styles = {
  wrapper: {
    paddingTop: 'env(safe-area-inset-top)',
    background: '#EDEAE3',
    padding: '16px 16px 12px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },
  title: {
    margin: 0,
    fontSize: 22,
    fontWeight: 700,
    color: '#1A1A1A',
    letterSpacing: '-0.01em',
  },
  subtitle: {
    margin: '4px 0 0',
    fontSize: 13,
    color: '#6B6B6B',
  },
  fallback: {
    background: '#FFF4D6',
    color: '#1A1A1A',
    padding: '8px 12px',
    borderRadius: 12,
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    lineHeight: 1.4,
  },
};
